import React from 'react';
import { ShadedBox } from '../Common/ShadedBox';
import { Subtitle } from '../Common/Subtitle';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { assetUrl } from '~/helpers';

const onBookCallClick = () => {
  window.open(
    'https://calendly.com/d/5b7-68t-47v/call-with-bonjoro-re-managing-subscription',
    '_blank',
    'noopener, noreferrer'
  );
};

export type CustomerSupportPanelProps = {
  title?: string;
  subtitle?: string;
  primaryButtonText?: string;
  primaryButtonOnClick?: () => void;
  secondaryButtonText?: string;
  secondaryUrl?: string;
  className?: string;
};
export function CustomerSupportPanel({
  title = 'Do you have issues or questions?',
  subtitle = ' Reach out to Grant, our Head of Customer Success. He can help you with any problems you might be facing.',
  primaryButtonText = 'Chat with the team',
  primaryButtonOnClick = onBookCallClick,
  secondaryButtonText = 'Email Grant',
  secondaryUrl = 'mailto:grant@bonjoro.com',
  className = '',
}: CustomerSupportPanelProps) {
  return (
    <ShadedBox
      className={`block h-full flex flex-col xmd:flex-row gap-x-4 gap-y-4 items-center lg:items-start ${className}`}
    >
      <img
        src={assetUrl('/assets/images/joro/cs-bear.png')}
        className='w-[200px] h-[144px]'
      />
      <div className='flex flex-col gap-y-4 items-center text-center xmd:items-start xmd:text-left'>
        <Subtitle label={title} />
        <span className='text-base leading-relaxed v2-text-neutral-900'>
          {subtitle}
        </span>
        <span className='flex flex-col lg:flex-row flex-wrap gap-y-4 gap-x-6 items-center xmd:items-start w-full'>
          <Button
            variant={ButtonVariant.Primary}
            className='py-2 w-full lg:w-auto'
            onClick={primaryButtonOnClick}
          >
            {primaryButtonText}
          </Button>
          <a
            href={secondaryUrl}
            target='_blank'
            className='w-full lg:w-auto'
            rel='noreferrer'
          >
            <Button
              variant={ButtonVariant.Secondary}
              className='py-2 w-full v2-text-neutral-900'
            >
              {secondaryButtonText}
            </Button>
          </a>
        </span>
      </div>
    </ShadedBox>
  );
}
